import { createContext, useContext } from "react";

const NxplanScopeContext = createContext(null);

export const NxplanScopeProvider = ({ value, children }) => (
  <NxplanScopeContext.Provider value={value}>
    {children}
  </NxplanScopeContext.Provider>
);

export const useNxplanScopeContext = () => {
  const context = useContext(NxplanScopeContext);
  if (!context) {
    throw new Error(
      "useNxplanScopeContext must be used within NxplanScopeProvider",
    );
  }
  return context;
};
